import React from "react";
import "../styles/CookiePolicyPage.css";

const CookiePolicyPage = () => {
    return (
        <div className="cookie-policy-page">
            <h1 className="cookie-policy-title">Cookie Policy</h1>
            <p className="effective-date"><strong>Effective Date: January 12, 2025</strong></p>

            <h2 className="cookie-section-title">1. What Are Cookies</h2>
            <p>
                As is common practice with almost all professional websites, <a href="https://www.brandbounce.io">www.brandbounce.io</a>
                ("the Site") uses cookies, which are tiny files that are downloaded to your computer, to improve your experience.
                This page describes what information they gather, how we use it, and why we sometimes need to store these cookies.
                We will also share how you can prevent these cookies from being stored; however, this may downgrade or "break" certain
                elements of the Site’s functionality.
            </p>

            <h2 className="cookie-section-title">2. How We Use Cookies</h2>
            <p>
                We use cookies for a variety of reasons detailed below. Unfortunately, in most cases, there are no industry standard
                options for disabling cookies without completely disabling the functionality and features they add to the Site.
                It is recommended that you leave on all cookies if you are not sure whether you need them or not, in case they are
                used to provide a service that you use.
            </p>

            <h2 className="cookie-section-title">3. Disabling Cookies</h2>
            <p>
                You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this).
                Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling
                cookies will usually result in also disabling certain functionality and features of this Site. Therefore, it is recommended
                that you do not disable cookies.
            </p>

            <h2 className="cookie-section-title">4. The Cookies We Set</h2>
            <ul>
                <li>
                    <strong>Account-related cookies:</strong> If you create an account with us, we will use cookies for the management
                    of the signup process and general administration. These cookies will usually be deleted when you log out; however,
                    in some cases, they may remain afterward to remember your site preferences when logged out.
                </li>
                <li>
                    <strong>Login-related cookies:</strong> We use cookies when you are logged in so that we can remember this fact.
                    This prevents you from having to log in every single time you visit a new page. These cookies are typically removed
                    or cleared when you log out to ensure that you can only access restricted features and areas when logged in.
                </li>
                <li>
                    <strong>Order processing-related cookies:</strong> This site offers e-commerce or payment facilities, and some
                    cookies are essential to ensure that your order is remembered between pages so that we can process it properly.
                </li>
                <li>
                    <strong>Survey-related cookies:</strong> From time to time, we offer user surveys and questionnaires to provide you
                    with interesting insights, helpful tools, or to understand our user base more accurately. These surveys may use
                    cookies to remember who has already taken part in a survey or to provide you with accurate results after you change pages.
                </li>
                <li>
                    <strong>Form-related cookies:</strong> When you submit data through a form, such as those found on contact pages or
                    comment forms, cookies may be set to remember your user details for future correspondence.
                </li>
            </ul>

            <h2 className="cookie-section-title">5. Third-Party Cookies</h2>
            <p>
                In some special cases, we also use cookies provided by trusted third parties. The following section details which third-party
                cookies you might encounter through this site:
            </p>
            <ul>
                <li>
                    <strong>Google Analytics:</strong> This site uses Google Analytics, one of the most widespread and trusted analytics
                    solutions on the web, for helping us understand how you use the site and ways that we can improve your experience.
                    These cookies may track things such as how long you spend on the site and the pages that you visit, so we can continue
                    to produce engaging content.
                </li>
            </ul>

            <h2 className="cookie-section-title">6. Consent Mechanism</h2>
            <p>
                Upon visiting our website, you will be prompted to accept or decline the use of cookies. Your consent applies to the
                following domains: <a href="https://www.brandbounce.io">www.brandbounce.io</a>. You can change your consent at any
                time by revisiting our website and adjusting your preferences.
            </p>

            <h2 className="cookie-section-title">7. More Information</h2>
            <p>
                Hopefully, that has clarified things for you, and as was previously mentioned, if there is something that you aren't sure
                whether you need or not, it’s usually safer to leave cookies enabled in case it interacts with one of the features you use
                on our site. However, if you are still looking for more information, you can contact us at
                <a href="mailto:office@brandbounce.io"> office@brandbounce.io</a>.
            </p>
        </div>
    );
};

export default CookiePolicyPage;